<div *ngIf="show" class="modalLoading">
  <div class="modalOverlay"></div>
  <div class="modalContainer">
    <div class="modalContent">
      <div class="title">{{title}}</div>
      <div class="pulse">
        <div class="dot left"></div>
        <div class="dot center"></div>
        <div class="dot right"></div>
      </div>
    </div>
  </div>
</div>